import React from "react";
import List from "features/WarrantyRequest/List";

const WarrantyRequest = () => {
  return <List />;
};

export default WarrantyRequest;
